import { PrimaryButton } from '@entur/button';
import { AddIcon, AdditionalIcon } from '@entur/icons';
import { useToast } from '@entur/alert';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import styles from './styles.module.scss';
import { getEnv } from 'utils/getEnv';

interface NewButtonProps {
  text: string;
  link: string;
  asRef?: boolean;
  withCopy?: boolean;
  DTOtype?: string;
}

const NewButton = ({ text, link, asRef = false, withCopy = false, DTOtype }: NewButtonProps) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { addToast } = useToast();

  const copyDTO = async () => {
    try {
      const clip = await navigator.clipboard.readText();
      const parsed = JSON.parse(clip);
      if (parsed?.options?.type === DTOtype) {
        navigate(link, {
          state: { ...parsed, new: true },
        });
        addToast({
          content: `${intl.formatMessage({ id: 'toastAlerts.pasted' })} ${getEnv(parsed.options.path)}`,
          variant: 'info',
        });
      } else {
        addToast({
          title: intl.formatMessage({ id: 'warnings.wrongType' }, { data: DTOtype }),
          // @ts-expect-error error is not a valid variant
          variant: 'error',
        });
      }
    } catch (error) {
      if (error instanceof DOMException) {
        addToast({
          title: intl.formatMessage({ id: 'toastAlerts.errorCopyPermission' }, { data: error.message }),
          // @ts-expect-error error is not a valid variant
          variant: 'error',
        });
      } else {
        addToast({
          title: intl.formatMessage({ id: 'toastAlerts.noValidData' }),
          // @ts-expect-error error is not a valid variant
          variant: 'error',
        });
      }
    }
  };

  if (asRef) {
    return (
      <PrimaryButton className={styles.hrefButton} as="a" href={link}>
        <AddIcon className={styles.hrefIcon} />
        {text}
      </PrimaryButton>
    );
  }

  return (
    <div className={styles.organisationsWrapper}>
      <div className={styles.organisationsButtonWrapper}>
        <PrimaryButton
          onClick={() => {
            navigate({
              pathname: link,
            });
          }}
        >
          <AddIcon className={styles.newIcon} />
          {text}
        </PrimaryButton>
        {withCopy && (
          <PrimaryButton className={styles.pasteButton} onClick={copyDTO}>
            <AdditionalIcon className={styles.newIcon} />
            {intl.formatMessage({ id: 'generalValues.import' })}
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};

export default NewButton;
